// Libraries
import React, { useEffect, useRef } from 'react'

// Constants
import { ModuleNames } from '../../../constants/componentNames.constants'
import {
  LanguageSelect as LanguageSelectorItems,
  LocaleCodes,
} from '../../../constants/localization.constants'

// Helpers

// Styles
import { internalLinkHandler } from '../../../utils/link.utils'
import Typography from '../typography'
import {
  Caret_Logo,
  Facebook_Logo,
  Globe_Logo,
  Instagram_logo,
  Linkedin_Logo,
  Security_Logo,
  Toutiao_Logo,
  Twitter_Logo,
  UIPath_Logo,
  Wechat_Logo,
  Wechat_QRCode,
  Weibo_Logo,
  Youku_Logo,
  Youtube_Logo,
} from './footerLogos'
import {
  FooterColumn,
  FooterInner,
  FooterLegal,
  FooterOuter,
  FooterSitemap,
  FooterSocial,
  FooterTopHat,
  LanguageSelector,
} from './style'

// Logos

// Components
import WrapperImage from '../wrapperImage'
const NewFooter = ({ locale, footerData }: any) => {
  const languageSelector = useRef<any>()
  const topHatLinks = footerData?.allContentfulNavMenu?.nodes?.[0]?.topHatLinks
  const menuGroups = footerData?.allContentfulNavMenu?.nodes?.[0]?.menuGroups
  const legalLinks = footerData?.allContentfulNavMenu?.nodes?.[0]?.legalFooterOnly
  const langCode = footerData?.allContentfulNavMenu?.nodes?.[0]?.node_locale

  // remove Spanish
  const LanguageSelect: any = { rows: [] }
  LanguageSelect.rows = LanguageSelectorItems?.rows?.filter((item: any) => item.title !== 'Spanish')

  const language =
    LanguageSelect?.rows?.filter((item: any) => item.code === locale)?.[0]?.title || 'English'

  const localePage =
    LanguageSelect?.rows?.filter((item: any) => item.code === locale)?.[0]?.href ||
    'https://www.uipath.com'

  const LINKEDIN = 'linkedin'
  const FACEBOOK = 'facebook'
  const TWITTER = 'twitter'
  const YOUTUBE = 'youtube'
  const INSTAGRAM = 'instagram'
  const WEIBO = 'weibo'
  const TOUTIAO = 'toutiao'
  const YOUKU = 'youku'
  const FOOTER_SOCIAL_INTRO = 'socials.footer.intro.text'
  const RIGHTS_RESERVED = 'rights.reserved.footer.text'
  const COOKIE_SETTING = 'cookie.setting.text'
  const ICP_NUMBER = 'icp.number.text'
  const SECURITY_NUMBER = 'security.number.text'
  const ICP_NUMBER_LINK = 'icp.number.link'
  const SECURITY_NUMBER_LINK = 'security.number.link'
  const COOKIE_SETTINGS_LINK = 'cookie-settings-link'
  const socialMicrocopySet =
    footerData?.allContentfulNavMenu?.nodes?.[0]?.socialMediaFooterOnly[0]?.values

  let socialData: any = {}
  socialMicrocopySet?.forEach((social: any) => {
    if (social.key.startsWith(LINKEDIN)) socialData.LINKEDIN = social.value
    else if (social.key.startsWith(FACEBOOK)) socialData.FACEBOOK = social.value
    else if (social.key.startsWith(TWITTER)) socialData.TWITTER = social.value
    else if (social.key.startsWith(YOUTUBE)) socialData.YOUTUBE = social.value
    else if (social.key.startsWith(INSTAGRAM)) socialData.INSTAGRAM = social.value
    else if (social.key.startsWith(WEIBO)) socialData.WEIBO = social.value
    else if (social.key.startsWith(TOUTIAO)) socialData.TOUTIAO = social.value
    else if (social.key.startsWith(YOUKU)) socialData.YOUKU = social.value
    else if (social.key === FOOTER_SOCIAL_INTRO) socialData.FOOTER_SOCIAL_INTRO = social.value
    else if (social.key === RIGHTS_RESERVED) socialData.RIGHTS_RESERVED = social.value
    else if (social.key === COOKIE_SETTING) socialData.COOKIE_SETTING = social.value
    else if (social.key === ICP_NUMBER) socialData.ICP_NUMBER = social.value
    else if (social.key === SECURITY_NUMBER) socialData.SECURITY_NUMBER = social.value
    else if (social.key === ICP_NUMBER_LINK) socialData.ICP_NUMBER_LINK = social.value
    else if (social.key === SECURITY_NUMBER_LINK) socialData.SECURITY_NUMBER_LINK = social.value
    else if (social.key === COOKIE_SETTINGS_LINK) socialData.COOKIE_SETTINGS_LINK = social.value
  })
  const buildColumn = (start: number, end: number, menuItems: any) => {
    let column = []
    for (let i = start; i < end; i++) {
      let heading = menuItems[i]?.newGroupName
      if (heading) column.push(<h6>{heading}</h6>)

      let index = 0
      let listItems = []

      for (let link of menuItems[i]?.pages) {
        let className =
          link?.__typename === ModuleNames.TOPIC_ICON_LINK
            ? { className: 'Footer__Text--Bold' }
            : {}

        listItems.push(
          <li key={index}>
            <a {...className} href={link?.url || link?.externalUrl}>
              {link?.text || link?.ctaText}
            </a>
          </li>
        )
        index++
      }

      column.push(<ul>{listItems}</ul>)
    }

    return <div>{column}</div>
  }

  const renderFooterLinks = () => {
    /*
      Only considering for desktop (12 column layout), responsive will be handled in styles,
      a menu list spans two columns width on desktop, hence two columns is 4.
    */
    const TWO_COLUMNS = 4
    const ONE_COLUMN = 2
    const COLUMN_END = 13

    let columnStart = 1,
      index = 1,
      finalMarkup = []

    for (let menuGroup of menuGroups) {
      let pages = menuGroup?.pages || []
      let columns = ONE_COLUMN

      // only split list into two columns if more than >= 4 menu groups
      if (pages.length >= 4) columns = TWO_COLUMNS

      let markup = []
      if (columns === TWO_COLUMNS) {
        let mid = Math.ceil(pages.length / 2)
        markup.push(buildColumn(0, mid, pages), buildColumn(mid, pages.length, pages))
      } else markup.push(buildColumn(0, pages.length, pages))

      columnStart = columnStart > COLUMN_END || columnStart + columns > COLUMN_END ? 1 : columnStart

      finalMarkup.push(
        <FooterColumn
          columns={columns}
          columnStart={columnStart}
          columnEnd={columnStart + columns}
          menuIndex={index}>
          <div className="Footer__Group-Title">
            <p>{menuGroup.newGroupName}</p>
            <span></span>
          </div>
          {markup}
        </FooterColumn>
      )

      columnStart += columns
      index++
    }
    return finalMarkup
  }

  const handleLanguageSelectorClick = (e: any) => {
    e.target.classList.toggle('LanguageSelector--Active')
  }

  const closeLanguageSelector = (e: any) => {
    if (!e.target.classList.contains('Footer__LanguageSelector'))
      languageSelector?.current?.classList?.remove('LanguageSelector--Active')
  }

  const handlePopOver = (e: any) => {
    const WeChatToggle = document.querySelector('a[data-target]')
    const WeChatPopup = document.getElementById('popover_wechat')
    if (WeChatToggle && WeChatPopup) {
      WeChatPopup.classList.toggle('open')
      const top = WeChatToggle.offsetTop - (WeChatPopup?.clientHeight + 15)
      const left = WeChatToggle.offsetLeft - WeChatPopup?.clientWidth / 2 + 12

      WeChatPopup.style.top = top + 'px'
      WeChatPopup.style.left = left + 'px'
    }
  }

  // OneTrust Consent Manager
  const oneTrustCustomWinLoad = (callback: any) => {
    if (document.readyState === 'complete') {
      callback()
    } else {
      window.addEventListener('load', callback)
    }
  }

  const loadOneTrust = (extraDelayMS: any) => {
    // Initialization of OneTrust Consent Manager
    setTimeout(function () {
      var s = document.createElement('script')
      s.type = 'text/javascript'
      s.charset = 'UTF-8'
      s.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
      s.async = true
      s.setAttribute('data-domain-script', '0614603d-bfe6-46ce-9263-9b2d0d1af676')
      s.setAttribute('nonce', '{{nonce}}')

      var i = document.getElementsByTagName('script')[0]
      i.parentNode.insertBefore(s, i)
      var s2 = document.createElement('script')
      s2.type = 'text/javascript'
      s2.setAttribute('nonce', '{{nonce}}')
      s2.innerHTML =
        "function OptanonWrapper() { window.dataLayer.push( { event: 'OneTrustGroupsUpdated'} );}"
      i.parentNode.insertBefore(s2, i)
    }, extraDelayMS)
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      const WeChatPopupResize = document.getElementById('popover_wechat')
      if (window.innerWidth > 767) {
        WeChatPopupResize?.classList.remove('open')
      }
    })

    window.addEventListener('click', closeLanguageSelector, false)

    if (langCode === LocaleCodes.CHINESE.code) {
      oneTrustCustomWinLoad(function () {
        loadOneTrust(500)
      })
    }

    return () => {
      return window.removeEventListener('click', closeLanguageSelector, false)
    }
  }, [])

  return (
    <FooterOuter>
      <FooterInner>
        {/* Footer Top Hat */}
        <FooterTopHat>
          <a href={localePage} className="Footer__UIPathLogo">
            {UIPath_Logo}
          </a>
          {topHatLinks?.length && (
            <div>
              {topHatLinks.map((item: any, index: number) => {
                let imgSrc = item?.icon?.image?.file?.url
                let imgAlt = item?.icon?.altText
                return (
                  <a href={item.url} className="Footer__TopHatLink Footer__Text--Bold">
                    {imgSrc && (
                      <div>
                        <img src={imgSrc} alt={imgAlt} />
                      </div>
                    )}
                    {item.ctaText}
                  </a>
                )
              })}
            </div>
          )}
          <LanguageSelector
            ref={languageSelector}
            className="Footer__LanguageSelector"
            onClick={handleLanguageSelectorClick}>
            {Globe_Logo}
            <Typography className="LanguageSelector__CurrentLocale" type="bodyXS">
              {language}
            </Typography>
            {Caret_Logo}
            <ul>
              {LanguageSelect.rows.map((lang: any, index: number) => {
                let className =
                  lang.title === language ? { className: 'LanguageSelector__Locale--Active' } : {}
                return (
                  <li key={index} {...className}>
                    <a href={lang.href}>
                      <Typography type="bodyXS">{lang.title}</Typography>
                    </a>
                  </li>
                )
              })}
            </ul>
          </LanguageSelector>
        </FooterTopHat>
        {/* Footer Site Map */}
        <FooterSitemap>{renderFooterLinks()}</FooterSitemap>
        {/* Footer Social */}

        {Object.keys(socialData)?.length > 0 && (
          <FooterSocial>
            <div className="Footer__SocialNetwork">
              <div>
                {socialData.FOOTER_SOCIAL_INTRO && (
                  <Typography className="Footer__SocialNetwork-IntroText" type="body">
                    {socialData.FOOTER_SOCIAL_INTRO}
                  </Typography>
                )}
                <ul>
                  {langCode === LocaleCodes.CHINESE.code ? (
                    <>
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={handlePopOver}
                          data-target="popover_wechat">
                          {Wechat_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.WEIBO} target="_blank">
                          {Weibo_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.TOUTIAO} target="_blank">
                          {Toutiao_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.LINKEDIN} target="_blank">
                          {Linkedin_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.YOUKU} target="_blank">
                          {Youku_Logo}
                        </a>
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <a href={socialData.FACEBOOK} target="_blank">
                          {Facebook_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.LINKEDIN} target="_blank">
                          {Linkedin_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.TWITTER} target="_blank">
                          {Twitter_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.YOUTUBE} target="_blank">
                          {Youtube_Logo}
                        </a>
                      </li>
                      <li>
                        <a href={socialData.INSTAGRAM} target="_blank">
                          {Instagram_logo}
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>

            {langCode === LocaleCodes.CHINESE.code ? (
              <div id="popover_wechat" className="popover" role="tooltip">
                <div className="parrow"></div>
                <div className="popover-body">
                  <div className="qr-img">
                    <WrapperImage src={Wechat_QRCode} />
                  </div>

                  <div className="qrcode-section">
                    <div className="wc-qr-desktop">
                      <Typography type="bodyXS">使用微信扫描二维码关注我们</Typography>
                    </div>
                    <div className="wc-qr-tablet">
                      <Typography type="bodyXS">使用微信扫描二维码关注我们</Typography>
                      <Typography type="bodyXS">
                        或者在微信中搜索公众号 <a href="https://www.uipath.com.cn/">UiPathChina</a>
                      </Typography>
                    </div>
                    <div className="wc-qr-mobile">
                      <Typography type="bodyXS">
                        长按二维码保存至相册，打开微信识别二维码关注我们。
                      </Typography>
                      <Typography type="bodyXS">
                        在微信中搜索公众号 <a href="https://www.uipath.com.cn/">UiPathChina</a>
                        ，同样能找到我们。
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </FooterSocial>
        )}
        {/* Footer Legal */}
        {legalLinks?.length && (
          <FooterLegal>
            <ul>
              {legalLinks.map((item: any, index: number) => {
                return (
                  <li>
                    <a
                      href={
                        item?.internalLink
                          ? internalLinkHandler(item?.internalLink)
                          : item?.externalUrl
                      }
                      key={index}>
                      {item?.text}
                    </a>
                  </li>
                )
              })}
              <li>
                {langCode === LocaleCodes.CHINESE.code ? (
                  <a id="ot-sdk-btn" className="ot-sdk-show-settings" rel="noopener">
                    {socialData.COOKIE_SETTING}
                  </a>
                ) : (
                  <a id="ot-sdk-btn" className="ot-sdk-show-settings" rel="noopener">
                    View cookie settings
                  </a>
                )}
              </li>
            </ul>
            <p>
              {langCode === LocaleCodes.CHINESE.code ? (
                <>
                  <a
                    href={socialData.ICP_NUMBER_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nohover">
                    {socialData.ICP_NUMBER}
                  </a>
                  <a href={socialData.SECURITY_NUMBER_LINK} target="_blank" className="nohover">
                    {Security_Logo}
                    {socialData.SECURITY_NUMBER}
                  </a>
                </>
              ) : null}
              {` © 2005-${new Date().getFullYear()} ${socialData.RIGHTS_RESERVED}`}
            </p>
          </FooterLegal>
        )}
      </FooterInner>
    </FooterOuter>
  )
}

export default NewFooter
